import type { Segment, UpdateSegmentInput } from '../types/segments.types';

export const buildRenameSegmentInput = (
  segment: Pick<Segment, 'name' | 'description'>,
  name: string,
  description: string
): UpdateSegmentInput => {
  const trimmedName = name.trim();
  const trimmedDescription = description.trim();
  const originalDescription = (segment.description ?? '').trim();

  const input: UpdateSegmentInput = { name: trimmedName };
  if (trimmedDescription !== originalDescription) {
    input.description = trimmedDescription;
  }
  return input;
};
